export const preferenceTableSchema = [
  {
    dataField: "id",
    text: "Voice Id",
    hidden: true,
  },
  {
    dataField: "accountnumber_int",
    text: "Account",
    sort: true,
  },
  {
    dataField: "eventtype_vch",
    text: "Type",
    sort: true,
  },
  {
    dataField: "subeventtype_vch",
    text: "Sub Type",
    sort: true,
  },
  {
    dataField: "contact_channel_vch",
    text: "Channel",
    sort: true,
  },
  {
    dataField: "contact_string_vch",
    text: "Contact",
    sort: true,
  },
  {
    dataField: "dnd_starttime_vch",
    text: "DND Start Time",
    sort: true,
    //,formatter: (dndStart)=>formatSqlDate(dndStart)
  },
  {
    dataField: "dnd_endtime_vch",
    text: "DND End Time",
    sort: true,
    //,formatter: (dndEnd)=>formatSqlDate(dndEnd)
  },
];
